import React from 'react';
import {
  LayoutGrid,
  Truck,
  Tag,
  Fuel,
  CircleDollarSign,
  Database,
  Send,
  ChevronLeft
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const getEnv = (key) => {
  if (typeof window !== 'undefined' && window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  return import.meta.env[key];
};

// ============================================
// CONFIGURAÇÃO DAS URLs
// ============================================
const PAINEL_URL = getEnv('VITE_PAINEL_URL')
// ============================================

const menuItems = [
  { id: 'grupo-mucuripe', label: 'Grupo Mucuripe', icon: LayoutGrid, path: '/' },
  { id: 'mucuripe-logistica', label: 'Mucuripe Logística', icon: Truck, path: '/mucuripe-logistica' },
  { id: 'mucuripe-varejo', label: 'Mucuripe Varejo', icon: Tag, path: '/mucuripe-varejo' },
  { id: 'postos-mucuripe', label: 'Postos Mucuripe', icon: Fuel, path: '/postos-mucuripe', isCurrentDashboard: true },
  { id: 'preco-justo', label: 'Preço Justo', icon: CircleDollarSign, path: '/preco-justo' },
  { id: 'sagas', label: 'Sagás', icon: Database, path: '/sagas' },
  { id: 'fontur-eventos', label: 'Fontur Eventos e turismo', icon: Send, path: '/fontur-eventos' },
];

const SIDEBAR_WIDTH = 280;

const Sidebar = ({ isOpen = false, onClose }) => {
  const { painelUrl } = useAuth();
  const basePainelUrl = painelUrl || PAINEL_URL;

  // Função para navegar para o painel
  const handleNavigateToPanel = (path) => {
    // Passar o token para manter a sessão
    const token = localStorage.getItem('authToken');
    if (token) {
      // O painel vai verificar o token do localStorage, então só precisa redirecionar
      window.location.href = `${basePainelUrl}${path}`;
    } else {
      window.location.href = `${basePainelUrl}/login`;
    }
  };

  return (
    <>
      {/* Overlay para fechar ao clicar fora (mobile) */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/20 z-40 md:hidden"
          onClick={onClose}
        />
      )}

      <aside
        className={`fixed top-0 left-0 h-full bg-white border-r border-gray-200 z-50 transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full'
          }`}
        style={{ width: SIDEBAR_WIDTH }}
      >
        <div className="h-full flex flex-col">
          {/* Header com Logo e botão fechar */}
          <div className="p-6 border-b border-gray-100">
            <div className="flex items-center justify-center relative">
              <button
                onClick={() => handleNavigateToPanel('/')}
                className="flex items-center space-x-3 flex-shrink-0 mx-auto"
              >
                <img
                  src="/Group.png"
                  alt="Grupo Mucuripe"
                  className="h-10 w-auto"
                  onError={(e) => {
                    // Fallback caso a imagem não exista no dashboard
                    e.target.style.display = 'none';
                  }}
                />
              </button>

              {/* Botão fechar */}
              <button
                onClick={onClose}
                className="absolute right-0 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
                title="Fechar menu"
              >
                <ChevronLeft className="w-5 h-5 text-gray-500" />
              </button>
            </div>
          </div>

          {/* Navigation */}
          <nav className="flex-1 p-4 overflow-y-auto">
            <ul className="space-y-1">
              {menuItems.map((item) => {
                const Icon = item.icon;
                const isActive = item.isCurrentDashboard; // "Postos Mucuripe" é o dashboard atual

                return (
                  <li key={item.id}>
                    <button
                      type="button"
                      onClick={() => {
                        if (item.isCurrentDashboard) {
                          // Já está no dashboard, apenas fechar sidebar
                          onClose?.();
                        } else {
                          // Navegar para o painel
                          handleNavigateToPanel(item.path);
                        }
                      }}
                      className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 group ${isActive
                          ? 'bg-[#1e3a5f] text-white shadow-md'
                          : 'text-gray-700 hover:bg-gray-100'
                        }`}
                    >
                      <Icon
                        className={`w-5 h-5 flex-shrink-0 ${isActive ? 'text-white' : 'text-gray-500 group-hover:text-gray-700'
                          }`}
                      />
                      <span
                        className={`text-sm font-medium whitespace-nowrap ${isActive ? 'text-white' : 'text-gray-700'
                          }`}
                      >
                        {item.label}
                      </span>
                    </button>
                  </li>
                );
              })}
            </ul>
          </nav>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;

